import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_ServerAddress } from '../MyAppCommonConfig';
import { TestCost } from '../models/admissionOfHpvryPatients.component.models/testCost';
import { Csave } from '../models/admissionOfHpvryPatients.component.models/Csave';

@Injectable()
export class admissionOfHpvryPatientscomponentservices{
  constructor(private http: HttpClient) {

  }
  GetStatusAnswer(id) {
    debugger;
    return this.http.get<TestCost[]>(API_ServerAddress + 'api/TestAcception/GetTestCosts/'+2);
  }
  GetAcceptionPaymentUrl(fCode: string, fReturnUrlSuccess: string, fReturnUrlFailure: string): string {
    return API_ServerAddress + '/api/Payment/StartBuy?fId=' + fCode + '&TypeFactorFlag=1&fReturnUrlSuccess=' + fReturnUrlSuccess + '&fReturnUrlFailure=' + fReturnUrlFailure;
  }
  CreateNew(viewModel: Csave) {
    return this.http.post(API_ServerAddress + 'api/TestAcception/SaveAcception', viewModel);
  }
  GetTestAcceptationCost() {
    return this.http.get(API_ServerAddress + 'api/TestType/GetSingle/2');
  }
}
